export default __webpack_public_path__ + "static/media/plusOn.f19f7226.svg";